import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./css/AddComputers.css"; // Ensure this CSS file is created for styling
import ApproveImage from './img/approve.png';
import ApprovalWaitingImage from './img/approval_waiting.png';

import { ApiUrl } from "./../../components/ApiUrl";
import { FaEdit, FaTrash, FaEye, FaTimes, FaImages, FaChevronDown } from "react-icons/fa"; // Import icons
import Modal from "react-modal";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick"; // Import Slider from react-slick
import { FaPlusCircle, FaClone, FaInfoCircle } from "react-icons/fa"; // Ensure to import any icons you need
import CouponEditPopup from "./CouponEditPopup";
import EditCouponModal from "./EditCouponModal"; // Import the modal component
import ActiveCouponImage from './img/Active-coupon.png'
import ExpiredCouponImage from './img/Expired-coupon.png'
import AccessoriesImage from './img/Accessories.png'
import { toast } from "react-toastify";
// import { FilterIcon } from "lucide-react";
// import leftarrow from "./img/left.png";
// import rightarrow from "./img/right.png";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { SearchIcon } from "lucide-react";
import FilterIcon from "./img/filter.png";

// Set up the modal root element
Modal.setAppElement("#root");

const Computers = () => {
  const [products, setProducts] = useState([]);
  const [newProduct, setNewProduct] = useState({
    name: "",
    images: [],
    features: "",
    price: "",
    label: "",
    subtitle: "",
    deliverycharge: "",
    category: "",
    coupon: "",
    coupon_expiry_date: "",
    actual_price: "",
    memory: "",
    storage: "",
    processor: "",
    // camera: "",
    display: "",
    // battery: "",
    os: "",
    // network: "",
    others: "",
  });
  const fileInputRef = useRef(null);
  const [imageCount, setImageCount] = useState(0);
  const [editingProduct, setEditingProduct] = useState(null); // To handle the product being edited
  const [modalIsOpen, setModalIsOpen] = useState(false); // Modal open/close state
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  // const [currentImage, setCurrentImage] = useState('');
  const [productId, setProductId] = useState(null); // State to hold the product ID
  const [selectedFile, setSelectedFile] = useState(null); // State for selected file
  const [imageIndex, setImageIndex] = useState(null);
  const [newImages, setNewImages] = useState({});
  // const [isPopupVisible, setPopupVisible] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [isViewingCoupons, setIsViewingCoupons] = useState(false);
  const [coupons, setCoupons] = useState([]);
  const [isEditingCoupon, setIsEditingCoupon] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [productName, setproductName] = useState(null);
  const [selectedProductPrice, setSelectedProductPrice] = useState(null);
  const [isFrequentlyBuyModalOpen, setIsFrequentlyBuyModalOpen] = useState(false);
  const [selectedAccessories, setSelectedAccessories] = useState([]);
  const [computerAccessories, setComputerAccessories] = useState([]);
  const [currentProductId, setCurrentProductId] = useState(null);
  const [isOfferModalOpen, setIsOfferModalOpen] = useState(false); // Renamed state
  const [offerStartTime, setOfferStartTime] = useState("");
  const [offerEndTime, setOfferEndTime] = useState("");
  const [offerPrice, setOfferPrice] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [modalProductId, setModalProductId] = useState(null);
  const [isOfferActive, setIsOfferActive] = useState(true);
  const [, setProduct] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [lightboxImages, setLightboxImages] = useState([]);

  const [couponProducts, setCouponProducts] = useState({});
  const [accessoryCounts, setAccessoryCounts] = useState({});

  const [searchTerm, setSearchTerm] = useState("");
  const [showOutOfStockOnly, setShowOutOfStockOnly] = useState(false);
  const [showHasCouponOnly, setShowHasCouponOnly] = useState(false);
  const [showHasAccessoriesOnly, setShowHasAccessoriesOnly] = useState(false);
  const [, setLoadingProductId] = useState(null);
  const userRole = localStorage.getItem("userRole"); // Assuming user role is stored as "admin" or "user"
  const [margin, setMargin] = useState([]);   // ⭐ main state for margins

  const fetchMargins = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/api/margins/get-margins`);
      console.log("Fetched Margins:", response.data);
      setMargin(response.data || []);
    } catch (err) {
      console.error("Error fetching margin rules:", err);
    }
  };

  // ⭐ Load margin rules when page loads
  useEffect(() => {
    fetchMargins();
  }, []);

  const handleStatusChange = async (newStatus, productId) => {
    try {
      const res = await axios.post(
        `${ApiUrl}/api/products/status`,
        {
          productId,
          status: newStatus,
        }
      );

      if (res.data.success) {
        // Show success toast with config
        toast.success("Product status updated successfully", {
          position: "top-right",
          autoClose: 3000,        // Close after 3 seconds
          hideProgressBar: true,  // No progress bar
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // //  Refresh product list
        // const refreshedProducts = await axios.get(`${ApiUrl}/adminfetchcomputers`, {
        //   timeout: 5000,
        //   params: { branch_id, userRole },
        // });

        // console.log("Refreshed product list:", refreshedProducts.data);

        // // Update the product list in state
        // setProducts(refreshedProducts.data);
        fetchProducts();


      } else {
        //  Show error toast
        toast.error("Failed to update product status");
      }
    } catch (err) {
      console.error("Error updating product status:", err);
      toast.error("Something went wrong while updating status");
    }
  };


  const handleStatusUpdate = async (prodId) => {
    try {
      console.log(`Updating productStatus for prod_id=${prodId}`);
      setLoadingProductId(prodId); // Mark this product as loading

      const newStatus = "approved"; // Always set to approved

      // Update product status with a timeout of 5 seconds
      const response = await axios.post(
        `${ApiUrl}/product-status/update`,
        {
          prod_id: prodId,
          productStatus: newStatus,
        },
        { timeout: 5000 } // 5-second timeout
      );

      if (response.status === 200) {
        console.log(`Product ${prodId} approved`);
        toast.success("Product approved successfully", {
          position: "top-right",
          autoClose: 3000, // Close after 3 seconds
          hideProgressBar: true, //  No progress bar
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // // Refresh product list
        // const refreshedProducts = await axios.get(`${ApiUrl}/adminfetchcomputers`, {
        //   timeout: 5000,
        //   params: { branch_id, userRole },
        // });
        // console.log("Refreshed product list:", refreshedProducts.data);

        // // Update the product list in state
        // setProducts(refreshedProducts.data);
        fetchProducts();

      } else {
        console.warn(`Failed to update product ${prodId}`);
        toast.error(" Failed to update product status", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error(`Error updating product ${prodId}:`, error.message);
      if (error.code === "ECONNABORTED") {
        toast.error(" Request timed out. Please try again.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
        });
      } else {
        toast.error(" An error occurred while updating product status", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
        });
      }
    } finally {
      setLoadingProductId(null); // Clear loading state
      console.log(`Status update finished for prod_id: ${prodId}`);
    }
  };



  useEffect(() => {
    const loadAccessoryCounts = async () => {
      const result = {};
      for (const product of products) {
        const count = await fetchAccessoryCount(product.prod_id);
        result[product.id] = count;
      }
      setAccessoryCounts(result);
    };

    if (products.length > 0) {
      loadAccessoryCounts();
    }
  }, [products]);

  const fetchAccessoryCount = async (productId) => {
    try {
      const response = await axios.get(`${ApiUrl}/api/accessorycount/${productId}`);
      const { accessoryCount } = response.data;
      return accessoryCount;
    } catch (error) {
      console.error(`[ERROR] Failed to fetch accessory count for product ${productId}:`, error.message);
      return 0;
    }
  };

  const fetchCouponStatus = async (productId) => {
    console.log(`[INFO] Checking coupon for product ID: ${productId}`);

    try {
      const response = await axios.get(`${ApiUrl}/api/couponstatus/${productId}`);
      const { hasCoupon, isExpired } = response.data;

      console.log(`[SUCCESS] Product ${productId}: hasCoupon=${hasCoupon}, isExpired=${isExpired}`);
      return { hasCoupon, isExpired };
    } catch (error) {
      console.error(`[ERROR] Failed to check coupon for product ${productId}:`, error.message);
      return { hasCoupon: false, isExpired: false };
    }
  };

  useEffect(() => {
    const loadCouponStatuses = async () => {
      const result = {};

      for (const product of products) {
        const { hasCoupon, isExpired } = await fetchCouponStatus(product.prod_id);
        result[product.id] = { hasCoupon, isExpired };
      }

      setCouponProducts(result);
    };

    if (products.length > 0) {
      loadCouponStatuses();
    }
  }, [products]);


  const handleImageClick = (index, imageArray) => {
    setPhotoIndex(index); // starting image
    setLightboxImages(imageArray); // all images of this product
    setIsOpen(true); // open lightbox
  };

  useEffect(() => {
    const now = new Date();
    // console.log("Current Time:", now.toLocaleString());

    const activeProduct = products.find((item) => {
      if (!item.offer_start_time || !item.offer_end_time) {
        // console.log(`Skipping product ${item.prod_name} due to missing offer times.`);
        return false;
      }

      const offerStartTime = new Date(item.offer_start_time);
      const offerEndTime = new Date(item.offer_end_time);

      // console.log(
      //   `Checking product: ${item.prod_name}, Offer Start: ${offerStartTime.toLocaleString()}, Offer End: ${offerEndTime.toLocaleString()}`
      // );

      return offerStartTime <= now && offerEndTime > now;
    });

    if (activeProduct) {
      // console.log("Active Product Found:", activeProduct);
    } else {
      // console.log("No active product with a valid offer.");
    }

    setProduct(activeProduct || null);
    setIsOfferActive(!!activeProduct);

    // console.log(`Is Offer Active: ${!!activeProduct ? "Yes" : "No"}`);
  }, [products]);

  useEffect(() => {
    setTimeout(() => {
      const section = document.querySelector(".dotted-divider");
      if (section) {
        const offset = section.offsetTop - 70; // Adjust the margin (50px in this case)
        window.scrollTo({ top: offset, behavior: "smooth" });
      }
    }, 100);
  }, []);
  // Handle opening modal and passing productId

  const openProductModal = (productId) => {
    setModalProductId(productId);
    setIsModalOpen2(true);
  };

  const closeProductModal = () => {
    setIsModalOpen2(false);
    setModalProductId(null);
  };

  const handleOpenOfferModal = (id) => {
    // Renamed function
    setProductId(id);
    setIsOfferModalOpen(true);
  };

  const handleCloseOfferModal = () => {
    // Renamed function
    setIsOfferModalOpen(false);
    setProductId(null); // Clear the productId when closing
  };

  useEffect(() => {
    if (isOfferModalOpen && productId) {
      setIsEditMode(true);
      fetchOfferData(productId);
    } else {
      setIsEditMode(false);
    }
  }, [isOfferModalOpen, productId]);

  const fetchOfferData = async (id) => {
    try {
      const response = await axios.get(
        `${ApiUrl}/api/products/fetchoffer/${id}`
      );
      const { offer_start_time, offer_end_time, offer_price } = response.data;

      // The dates are already in the correct format from the backend
      setOfferStartTime(offer_start_time || "");
      setOfferEndTime(offer_end_time || "");
      setOfferPrice(offer_price || "");
    } catch (error) {
      console.error("Error fetching offer data", error);
    }
  };

  const handleChangePrice = (e, productPrice) => {
    const value = e.target.value;

    // Allow only numbers (integer or decimal with up to 2 places), but no leading zero unless decimal.
    const regex = /^(0|[1-9]\d*)(\.\d{0,2})?$/;

    if (regex.test(value) || value === "") {
      if (parseFloat(value) <= productPrice || value === "") {
        setOfferPrice(value);
      } else {
        Swal.fire({
          icon: "warning",
          title: "Invalid Price",
          text: `Offer price cannot exceed ${productPrice}`,
          confirmButtonColor: "#d33",
          timer: 3000,
        });
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!offerStartTime || !offerEndTime || !offerPrice) {
      Swal.fire({
        icon: "warning",
        title: "Please fill all fields",
        text: "Ensure all fields are filled out correctly before submitting.",
      });
      return;
    }

    const offerData = {
      offer_start_time: offerStartTime,
      offer_end_time: offerEndTime,
      offer_price: offerPrice,
    };

    try {
      if (isEditMode) {
        await axios.put(
          `${ApiUrl}/api/products/updateoffer/${productId}`,
          offerData
        );
        Swal.fire("Success!", "Offer updated successfully!", "success");
      } else {
        await axios.post(`${ApiUrl}/api/products/addoffer`, {
          ...offerData,
          productId,
        });
        Swal.fire("Success!", "Offer added successfully!", "success");
      }
      handleCloseOfferModal(); // Close the modal after successful submission
    } catch (error) {
      console.error("Error submitting offer", error);
      Swal.fire(
        "Error!",
        "There was an error processing your request. Please try again.",
        "error"
      );
    }
  };

  // Handle deletion of offer with confirmation
  const handleDelete = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${ApiUrl}/api/products/deleteoffer/${productId}`);
          Swal.fire("Deleted!", "Offer has been deleted.", "success");
          handleCloseOfferModal(); // Close the modal after deletion
        } catch (error) {
          console.error("Error deleting offer", error);
          Swal.fire(
            "Error!",
            "There was an error deleting the offer. Please try again.",
            "error"
          );
        }
      }
    });
  };

  const openPopup = (id, productName, prodPrice) => {
    // Set states
    setSelectedProductId(id);
    setSelectedProductPrice(prodPrice);
    setproductName(productName);
    setIsPopupOpen(true);

    // Log the parameters passed
    console.log("Product ID passed:", id);
    console.log("Product Name passed:", productName);
    console.log("Product Price passed:", prodPrice);

    // Use a timeout to log updated state after React processes the setState
    setTimeout(() => {
      console.log("Selected Product ID (state):", selectedProductId);
      console.log("Selected Product Price (state):", selectedProductPrice);
      console.log("Product Name (state):", productName);
      console.log("Popup open status (state):", isPopupOpen);
    }, 100);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedProductId(null);
  };

  // const handlePopupToggle = () => {
  //   setPopupVisible(!isPopupVisible);
  // };

  const fetchCoupons = async (productId, productName, productPrice) => {

    console.log(`Fetching coupons for product ID: ${productId}`); // Log when fetching starts

    try {
      const response = await axios.get(`${ApiUrl}/coupons/${productId}`); // Create this endpoint
      if (response.status === 200) {
        console.log(
          `Successfully fetched coupons for product ID: ${productId}`,
          response.data.coupons
        ); // Log successful response
        setCoupons(response.data.coupons); // Assuming your response has this structure
        console.log("coupon_data", response.data.coupons)
        setIsViewingCoupons(true); // Set to true to display the coupons
        setproductName(productName);
        setSelectedProductPrice(productPrice); // Set the product price for use
      }
    } catch (error) {
      console.error("Error fetching coupons:", error); // Log any error
    }
  };

  const handleCouponUpdated = () => {
    console.log("Coupon updated successfully!");
  };
  const MAX_FILES = 5; // Set your file limit

  const handleFileChange = (productId, event) => {
    const files = Array.from(event.target.files);

    // Get the existing files for this product (or an empty array)
    const existingFiles = newImages[productId] || [];
    const existingFileNames = existingFiles.map((file) => file.name);

    // Check if adding new files exceeds the limit
    if (existingFiles.length + files.length > MAX_FILES) {
      Swal.fire({
        icon: "warning",
        title: "File Limit Exceeded",
        text: `You can only upload up to ${MAX_FILES} images.`,
      }).then(() => {
        event.target.value = ""; // Clear the file input field
      });
      return;
    }

    // Filter out duplicate files based on name
    const uniqueFiles = files.filter(
      (file) => !existingFileNames.includes(file.name)
    );

    if (uniqueFiles.length === 0) return; // No new images

    // Directly add the unique original image files without resizing or compression
    setNewImages((prev) => ({
      ...prev,
      [productId]: [...(prev[productId] || []), ...uniqueFiles],
    }));
  };


  const handleUploadImages = async (productId) => {
    if (!newImages[productId] || newImages[productId].length === 0) {
      // If no new images, show an alert and exit
      Swal.fire({
        icon: "warning",
        title: "No Images Selected",
        text: "Please select images to upload before proceeding.",
        confirmButtonText: "OK",
      });
      return;
    }

    const formData = new FormData();
    newImages[productId].forEach((file) => {
      formData.append("images", file); // Append each image file
    });
    formData.append("productId", productId); // Append the product ID

    console.log(`Uploading images for product ID ${productId}...`); // Log upload attempt

    try {
      const response = await fetch(`${ApiUrl}/uploadcomputersimages`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        console.log("Images uploaded successfully for product ID:", productId); // Log success
        Swal.fire({
          icon: "success",
          title: "Upload Successful",
          text: "Images uploaded successfully!",
          confirmButtonText: "OK",
        }).then(() => {
          window.location.reload();
        });
      } else {
        console.error("Error uploading images for product ID:", productId); // Log error
        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text: "Error uploading images. Please try again.",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error uploading images:", error);
      Swal.fire({
        icon: "error",
        title: "Upload Error",
        text: "An error occurred while uploading images. Please try again.",
        confirmButtonText: "OK",
      });
    }
  };

  const openModal = (productId, imageIndex) => {
    setProductId(productId);
    setImageIndex(imageIndex);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setImageIndex(null);
    setProductId(null);
    setSelectedFile(null);
  };

  const settings = {
    dots: false, // Show dots
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // arrows: false, // Show arrows
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (!loggedIn) {
      navigate("/AdminLogin");
    }
  }, [navigate]);

  const branchData = JSON.parse(localStorage.getItem("branch"));
  const savedBranch = localStorage.getItem("current_branch") || "all";
  const branch_id = savedBranch === "all" ? null : savedBranch;

  const fetchProducts = async () => {
    try {

      // ✅ correct branch logic
      const currentBranch = localStorage.getItem("current_branch") || "all";
      const branchData = JSON.parse(localStorage.getItem("branch"));
      const loginBranchId = branchData?.id || null;
      const branch_id = currentBranch === "all" ? null : currentBranch;

      const userRole = localStorage.getItem("userRole");

      const response = await axios.get(`${ApiUrl}/adminfetchcomputers`, {
        params: { branch_id, userRole },
      });

      let filteredProducts = response.data;

      // Admin → ALL
      if (userRole === "Admin" && branch_id === null) {
        filteredProducts = filteredProducts.filter(item => item.branch_id !== null);
      }

      // Admin → specific branch
      else if (userRole === "Admin" && branch_id) {
        filteredProducts = filteredProducts.filter(item => item.branch_id == branch_id);
      }

      // branch admin → only own branch
      else if (userRole === "branch_admin" && loginBranchId) {
        filteredProducts = filteredProducts.filter(item => item.branch_id == loginBranchId);
      }

      setProducts(filteredProducts);
      console.log("📌 Final filtered products:", filteredProducts);

    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  useEffect(() => {

    fetchProducts();
  }, []);




  const handleChange = (e) => {
    const { name, value } = e.target;



    if (
      name === "price" ||
      name === "actual_price" ||
      name === "deliverycharge"
    ) {
      // Allow only numeric characters for price and actual_price
      const isNumeric = value === "" || /^[0-9]*\.?[0-9]*$/.test(value);
      if (!isNumeric) {
        // Optionally show an error message if the input is invalid
        Swal.fire({
          icon: "warning",
          title: "Invalid Input",
          text: "Price should only contain numbers.",
        });
        return; // Prevent updating state if invalid
      }
    }

    // If validation passes, update the newProduct state
    setNewProduct({
      ...newProduct,
      [name]: value,
    });
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      console.log("Selected image for upload:", file);

      // Generate unique filename with timestamp
      const timestamp = new Date().toISOString().replace(/[-:.]/g, ""); // Format: YYYYMMDDTHHMMSS
      const fileExtension = file.name.split(".").pop(); // Extract file extension
      const newFileName = `image_${timestamp}.${fileExtension}`;

      // Create new File instance with original content
      const newFile = new File([file], newFileName, { type: file.type });

      console.log("Prepared file for upload:", newFile);
      setSelectedFile(newFile);
    }
  };


  // Your existing handleImageUpdate function
  const handleImageUpdate = () => {
    const formData = new FormData();
    if (selectedFile) {
      formData.append("image", selectedFile);

      fetch(
        `${ApiUrl}/updatecomputers/image/${productId}?index=${imageIndex}`,
        {
          method: "PUT",
          body: formData,
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.message) {
            // Use SweetAlert2 to display success message
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: data.message,
              confirmButtonText: "OK",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          console.error("Error updating image:", error);
          // Optionally display an error alert
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "There was an error updating the image. Please try again.",
            confirmButtonText: "OK",
          });
        });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Warning!",
        text: "Please select a file to upload.",
        confirmButtonText: "OK",
      });
    }
  };

  const handleDeleteImage = (productId, imageIndex) => {
    // Confirm deletion from the user
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Make the DELETE request to the backend API
        fetch(
          `${ApiUrl}/deletecomputers/image/${productId}?index=${imageIndex}`,
          {
            method: "DELETE",
          }
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.message) {
              // Show success message
              Swal.fire("Image Deleted!", data.message, "success").then(() => {
                window.location.reload();
              });
              // Refresh the images or update the UI accordingly
              // Optionally, you can trigger a re-fetch of the images or update the state
            }
          })
          .catch((error) => {
            console.error("Error deleting image:", error);
            Swal.fire(
              "Error!",
              "There was an error deleting the image. Please try again.",
              "error"
            );
          });
      }
    });
  };

  // const handleImageChange = (e) => {
  //   setNewProduct({
  //     ...newProduct,
  //     image: e.target.files[0],
  //   });
  // };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    // If more than 5 images are selected, show an alert and prevent upload
    if (files.length > 5) {
      Swal.fire({
        icon: "warning",
        title: "Image Upload Limit",
        text: "You can upload a maximum of 5 images at a time.",
        confirmButtonText: "OK",
      });
      e.target.value = ""; // Reset input to allow re-selection
      return;
    }

    // Filter out duplicates based on file name
    setNewProduct((prevProduct) => {
      const existingImages = prevProduct.images.map((img) => img.name || img);

      const newUniqueImages = files.filter(
        (file) => !existingImages.includes(file.name)
      );

      return {
        ...prevProduct,
        images: [...prevProduct.images, ...newUniqueImages],
      };
    });

    setImageCount(files.length); // You can update this to only count unique if needed

    e.target.value = ""; // Reset file input
  };

  const handleAddProduct = async () => {
    if (newProduct.label && newProduct.label.replace(/\s/g, "").length > 15) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "Label cannot exceed 30 characters.",
      });
      return;
    }

    // Ensure label is not just spaces if provided
    if (newProduct.label && !newProduct.label.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "Label cannot be just spaces.",
      });
      return;
    }

    if (!newProduct.name.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "Product name is required.",
      });
      return;
    }

    if (
      !newProduct.price ||
      isNaN(newProduct.price) ||
      Number(newProduct.price) <= 0
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "A valid product price is required.",
      });
      return;
    }
    if (
      !newProduct.actual_price ||
      isNaN(newProduct.actual_price) ||
      Number(newProduct.actual_price) <= 0
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "A valid actual price is required.",
      });
      return;
    }
    if (!newProduct.images || newProduct.images.length === 0) {
      // Check for images array length
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "At least one product image is required.",
      });
      return;
    }

    // New validation check: actual_price should be greater than price
    if (Number(newProduct.actual_price) <= Number(newProduct.price)) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "Actual price must be greater than the product price.",
      });
      return;
    }

    const branchData = JSON.parse(localStorage.getItem("branch"));
    // if (!branchData || !branchData.id) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Unauthorized",
    //     text: "Branch information not found. Please login again.",
    //   });
    //   return;
    // }

    const savedBranch = localStorage.getItem("current_branch") || "all";

    let branch_id = savedBranch === "all" ? null : savedBranch;

    // logs
    console.log("📌 Saved Branch in localStorage:", savedBranch);
    console.log("📌 Final branch_id sent to backend:", branch_id);


    // Fetch user role from localStorage
    const userRole = localStorage.getItem("userRole"); // Assuming user role is stored as "admin" or "user"

    // Set product status based on user role
    const productStatus = userRole === "Admin" ? "approved" : "unapproved";

    const formData = new FormData();
    if (branch_id !== null) formData.append("branch_id", branch_id);

    formData.append("name", newProduct.name);
    // formData.append("features", newProduct.features);
    formData.append("price", newProduct.price);
    formData.append("actual_price", newProduct.actual_price);
    formData.append("label", newProduct.label);
    formData.append("subtitle", newProduct.subtitle);
    formData.append("deliverycharge", newProduct.deliverycharge);
    formData.append("coupon_expiry_date", newProduct.coupon_expiry_date);
    formData.append("coupon", newProduct.coupon);
    formData.append("category", newProduct.category);
    formData.append("memory", newProduct.memory);
    formData.append("storage", newProduct.storage);
    formData.append("processor", newProduct.processor);
    // formData.append("camera", newProduct.camera);
    formData.append("display", newProduct.display);
    // formData.append("battery", newProduct.battery);
    formData.append("os", newProduct.os);
    // formData.append("network", newProduct.network);
    formData.append("others", newProduct.others);
    formData.append("productStatus", productStatus);
    formData.append("user_role", userRole);

    // Append each image file to the FormData
    newProduct.images.forEach((image, index) => {
      if (image instanceof File) {
        formData.append("images", image);
      } else {
        formData.append(`images${index}`, image);
      }
    });

    try {
      await axios.post(`${ApiUrl}/computers`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Product Added",
        text: "The product has been added successfully!",
      });

      // // Fetch updated list of products
      // const response = await axios.get(`${ApiUrl}/adminfetchcomputers`, {
      //   params: { branch_id, userRole },
      // });
      // setProducts(response.data);
      fetchProducts();

      setNewProduct({
        name: "",
        images: [], // Reset images
        // features: "",
        price: "",
        actual_price: "",
        label: "",
        subtitle: "",
        deliverycharge: "",
        coupon_expiry_date: "",
        coupon: "",
        category: "", // Clear the category here
        memory: "",
        storage: "",
        processor: "",
        // camera: "",
        display: "",
        // battery: "",
        os: "",
        // network: "",
        others: "",
      });
      setImageCount(0);
      document.querySelector('input[type="file"]').value = ""; // Reset file input
    } catch (error) {
      console.error("Error adding product:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "There was an error adding the product. Please try again.",
      });
    }
  };

  const handleEditProduct = (product) => {
    if (!product) {
      console.log("No product provided to edit.");
      return;
    }

    console.log("Editing product:", product);

    let formattedDate = "";
    if (product.coupon_expiry_date) {
      const expiryDate = new Date(product.coupon_expiry_date);
      console.log(
        "Raw coupon expiry date:",
        product.coupon_expiry_date,
        "Parsed date:",
        expiryDate
      );

      if (!isNaN(expiryDate)) {
        const year = expiryDate.getFullYear();
        const month = String(expiryDate.getMonth() + 1).padStart(2, "0");
        const day = String(expiryDate.getDate()).padStart(2, "0");
        formattedDate = `${year}-${month}-${day}`;
        console.log("Formatted coupon expiry date:", formattedDate);
      } else {
        console.log("Invalid expiry date format:", product.coupon_expiry_date);
      }
    } else {
      console.log("No coupon expiry date available for the product.");
    }

    const editingProduct = {
      id: product.id || "", // Default to empty string if undefined
      prod_id: product.prod_id || "", // Map 'prod_id'
      name: product.prod_name || "", // Default to empty string if undefined
      image: null,
      memory: product.memory || "",
      storage: product.storage || "",
      processor: product.processor || "",
      // camera: product.camera || '',
      display: product.display || "",
      // battery: product.battery || '',
      os: product.os || "",
      // network: product.network || '',
      others: product.others || "",
      price: product.prod_price || 0, // Default to 0 if undefined
      actual_price: product.actual_price || 0, // Default to 0 if undefined
      label: product.offer_label || "",
      subtitle: product.subtitle || "",
      deliverycharge: product.deliverycharge || 0, // Default to 0 if undefined
      status: product.status || "",
      productStatus: product.productStatus || "",
      coupon_expiry_date: formattedDate,
      coupon: product.coupon || "",
      category: product.category || "",
    };

    console.log("Formatted editing product object:", editingProduct);

    setEditingProduct(editingProduct);
    console.log("Editing product state updated.");

    setModalIsOpen(true);
    openProductModal(false);
    console.log("Modal opened for editing.");
  };

  const handleUpdateProduct = async () => {
    // Validation for label
    if (editingProduct.label && !editingProduct.label.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "Label cannot be just spaces. Please remove the spaces.",
      });
      console.log("Validation failed: Label is just spaces.");
      return;
    }

    // if (editingProduct.label && /\d/.test(editingProduct.label)) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Invalid Input",
    //     text: "Label cannot contain numeric values.",
    //   });
    //   console.log("Validation failed: Label contains numeric values.");
    //   return;
    // }

    if (editingProduct.label && editingProduct.label.length > 15) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "Label cannot exceed 15 characters.",
      });
      console.log("Validation failed: Label exceeds 15 characters.");
      return;
    }

    // Validation for price comparison
    if (Number(editingProduct.actual_price) <= Number(editingProduct.price)) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "Actual price must be greater than the product price.",
      });
      console.log(
        "Validation failed: Actual price is not greater than product price."
      );
      return;
    }

    // Validation for product name
    if (!editingProduct.name.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "Product name is required.",
      });
      console.log("Validation failed: Product name is required.");
      return;
    }

    // Validation for valid price
    if (
      !editingProduct.price ||
      isNaN(editingProduct.price) ||
      Number(editingProduct.price) <= 0
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "A valid product price is required.",
      });
      console.log("Validation failed: Invalid product price.");
      return;
    }

    // Validation for actual price
    if (
      !editingProduct.actual_price ||
      isNaN(editingProduct.actual_price) ||
      Number(editingProduct.actual_price) <= 0
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Input",
        text: "A valid actual product price is required.",
      });
      console.log("Validation failed: Invalid actual product price.");
      return;
    }

    if (!editingProduct.prod_id) {
      console.error("Product ID is missing.");
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Product ID is missing.",
      });
      return;
    }

    console.log("Editing Product State Before Update:", editingProduct); // Log before update

    const formData = new FormData();
    formData.append("name", editingProduct.name);
    formData.append("prod_id", editingProduct.prod_id);
    formData.append("price", editingProduct.price);
    formData.append("actual_price", editingProduct.actual_price);
    formData.append("status", editingProduct.status);
    formData.append("productStatus", editingProduct.productStatus);
    formData.append("label", editingProduct.label);
    formData.append("subtitle", editingProduct.subtitle);
    formData.append("deliverycharge", editingProduct.deliverycharge);
    // formData.append("coupon_expiry_date", editingProduct.coupon_expiry_date);
    // formData.append("coupon", editingProduct.coupon);
    formData.append("memory", editingProduct.memory);
    formData.append("storage", editingProduct.storage);
    formData.append("processor", editingProduct.processor);
    // formData.append("camera", editingProduct.camera);
    formData.append("display", editingProduct.display);
    // formData.append("battery", editingProduct.battery);
    formData.append("os", editingProduct.os);

    // formData.append("network", editingProduct.network);
    formData.append("others", editingProduct.others);
    if (editingProduct.image) {
      formData.append("image", editingProduct.image);
    }

    try {
      console.log(
        "Sending update request to backend with form data:",
        formData
      );

      // Send update request to the backend
      const response = await axios.put(
        `${ApiUrl}/updatecomputers/${editingProduct.prod_id}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json", // Corrected the extra space
          },
        }
      );

      console.log("Update response status:", response.status);
      console.log("Update response data:", response.data);

      // Check if response status is 200 (success)
      if (response.status === 200) {
        // Assuming the backend sends a `success` field in the response
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Product Updated",
            text: "The product has been updated successfully!",
          });

          // // Fetch the updated list of products from the backend
          // const fetchResponse = await axios.get(`${ApiUrl}/adminfetchcomputers`, {
          //   params: { branch_id, userRole },
          // });
          // setProducts(fetchResponse.data);
          fetchProducts();

          // Reset the editing state and close the modal
          setEditingProduct(null);
          setModalIsOpen(false);

          // Log the updated product data (backend should return updated product details)
          console.log("Updated Product Details:", response.data.updatedProduct);
        } else {
          // Handle the case where success is false but the status is 200
          Swal.fire({
            icon: "error",
            title: "Update Failed",
            text:
              response.data.message ||
              "Failed to update the product. Please try again.",
          });
        }
      } else {
        // If the status code is not 200 (e.g., an error occurred)
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "Failed to update the product. Please try again.",
        });
      }
    } catch (error) {
      // Handle any unexpected errors
      console.error("Error during the update request:", error);
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "An unexpected error occurred. Please try again.",
      });
    }
  };

  const handleDeleteProduct = async (id) => {
    console.log("Attempting to delete product with ID:", id);

    // Show confirmation dialog
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this product? This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    // Check if the user confirmed the deletion
    if (confirmResult.isConfirmed) {
      try {
        // Log before sending delete request
        console.log(
          "Sending delete request to:",
          `${ApiUrl}/deletecomputers/${id}`
        );

        // Perform the delete operation
        const deleteResponse = await axios.delete(
          `${ApiUrl}/deletecomputers/${id}`
        );

        // Log response from delete request
        console.log("Delete response:", deleteResponse.data);

        // // Fetch updated list of products
        // const response = await axios.get(`${ApiUrl}/adminfetchcomputers`, {
        //   params: { branch_id, userRole },
        // });;
        // setProducts(response.data);

        // // Log the updated product list
        // console.log("Updated products list after deletion:", response.data);
        fetchProducts();

        // Show success alert
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "The product has been deleted successfully.",
        });
      } catch (error) {
        console.error("Error deleting product:", error);

        // Show error alert
        Swal.fire({
          icon: "error",
          title: "Delete Failed",
          text: "There was an error deleting the product. Please try again.",
        });
      }
    } else {
      console.log("Product deletion canceled by user.");
    }
  };

  const handleEditExpiry = (couponId) => {
    const couponToEdit = coupons.find(
      (coupon) => coupon.coupon_id === couponId
    );
    setSelectedCoupon(couponToEdit);
    setIsEditingCoupon(true);
    setSelectedProductPrice(selectedProductPrice); // Pass the price from state
  };

  const overlayStyle = {
    backgroundColor: "rgba(0, 0, 0, 0.7)", // Darker overlay for emphasis
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: "1000",
  };

  const modalStyle = {
    padding: "30px",
    width: "400px",
    borderRadius: "15px",
    background: "#ffffff",
    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
    position: "relative",
    top: "25%", // Positioning from the top
    left: "25%", // Positioning from the left
    transform: "translate(-50%, -50%)", // Centering the modal
  };
  const titleStyle = {
    fontSize: "26px",
    marginBottom: "25px",
    color: "#444",
    textAlign: "center",
  };

  const inputStyle = {
    display: "block",
    width: "100%",
    padding: "12px",
    marginBottom: "20px",
    border: "2px solid #007bff",
    borderRadius: "5px",
    fontSize: "16px",
  };

  const buttonStyle = {
    padding: "12px 20px",
    backgroundColor: "#28a745",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "16px",
    transition: "background-color 0.3s",
  };

  const buttonHoverStyle = {
    ...buttonStyle,
    backgroundColor: "#218838", // Darker shade on hover
  };

  // const handleAddPipe = () => {
  //   const textarea = document.querySelector(".laptops-card-input1"); // Get the textarea element by class
  //   const cursorPosition = textarea.selectionStart; // Get the cursor position

  //   // Insert the pipe at the cursor position
  //   const updatedFeatures = [
  //     newProduct.features.slice(0, cursorPosition),
  //     "|",
  //     newProduct.features.slice(cursorPosition),
  //   ].join("");

  //   // Update the features with the inserted pipe
  //   setNewProduct({
  //     ...newProduct,
  //     features: updatedFeatures,
  //   });

  //   // Return focus back to the textarea after insertion
  //   textarea.focus();
  // };

  // const handleUpdatePipe = () => {
  //   const textarea = document.querySelector(".adminmodal-input1"); // Get the textarea element by class
  //   const cursorPosition = textarea.selectionStart; // Get the cursor position

  //   // Insert the pipe at the cursor position
  //   const updatedFeatures = [
  //     editingProduct.features.slice(0, cursorPosition),
  //     "|",
  //     editingProduct.features.slice(cursorPosition),
  //   ].join("");

  //   // Update the features with the inserted pipe
  //   setEditingProduct({
  //     ...editingProduct,
  //     features: updatedFeatures,
  //   });

  //   // Return focus back to the textarea after insertion
  //   textarea.focus();
  // };

  const getFormattedDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`; // Format for datetime-local input
  };

  const today = new Date();
  const minDate = getFormattedDate(today);
  const maxDate = getFormattedDate(
    new Date(today.setDate(today.getDate() + 10))
  );

  // console.log("Min Date:", minDate);
  // console.log("Max Date:", maxDate);

  const handleDeleteCoupon = async (couponId) => {
    // Show confirmation popup
    const confirmation = await Swal.fire({
      toast: true,
      title: "Are you sure?",
      text: "This coupon will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#e74c3c",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (!confirmation.isConfirmed) return; // Exit if user cancels

    try {
      const response = await axios.delete(`${ApiUrl}/deletecoupons/${couponId}`);
      if (response.status === 200) {
        // Success toast
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Coupon deleted successfully",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        setCoupons(coupons.filter((coupon) => coupon.coupon_id !== couponId));
      }
    } catch (error) {
      console.error("Error deleting coupon:", error);

      // Error toast
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to delete the coupon",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    }
  };

  const handleOpenFrequentlyBuyModal = async (productId, category) => {
    console.log("[INFO] Opening Frequently Buy Modal");
    console.log(`[INFO] Product ID: ${productId}, Category: ${category}`);

    setCurrentProductId(productId);
    setIsFrequentlyBuyModalOpen(true);

    try {
      console.log("[INFO] Fetching accessories from API");
      const response = await fetch(
        `${ApiUrl}/getcomputeraccessories?productId=${productId}`
      );

      if (!response.ok) {
        const errorData = await response.text();
        console.error("[ERROR] Failed to fetch accessories:", errorData);
        return;
      }

      const data = await response.json();
      console.log("[INFO] Accessories fetched successfully:", data);

      // Check if the response contains the categoryAccessories array
      if (Array.isArray(data.categoryAccessories)) {
        setComputerAccessories(data.categoryAccessories);
      } else {
        console.error(
          "[ERROR] categoryAccessories is not an array:",
          data.categoryAccessories
        );
        setComputerAccessories([]); // Set to an empty array if there's an error
      }

      // Parse the selected accessories if they exist
      const selectedAccessories = data.additionalAccessories
        ? data.additionalAccessories.split(",")
        : [];
      console.log("[INFO] Pre-selected accessories:", selectedAccessories);

      setSelectedAccessories(selectedAccessories);
    } catch (error) {
      console.error("[ERROR] Error while fetching accessories:", error);
    }
  };

  const handleCloseFrequentlyBuyModal = () => {
    console.log("[INFO] Closing Frequently Buy Modal");
    setIsFrequentlyBuyModalOpen(false);
    setSelectedAccessories([]);
  };

  const handleAccessorySelection = async (e) => {
    const accessoryId = e.target.value;
    console.log(
      `[INFO] Accessory ID: ${accessoryId}, Checked: ${e.target.checked}`
    );

    if (e.target.checked) {
      console.log("[INFO] Adding accessory to the selected list");
      setSelectedAccessories((prev) => [...prev, accessoryId]);
    } else {
      console.log("[INFO] Removing accessory from the selected list");
      setSelectedAccessories((prev) => prev.filter((id) => id !== accessoryId));

      try {
        console.log("[INFO] Removing accessory from the backend");
        const response = await fetch(`${ApiUrl}/removefrequentlybuy`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            productId: currentProductId,
            accessoryId: accessoryId,
          }),
        });

        if (response.ok) {
          const data = await response.text();
          console.log("[INFO] Accessory removed successfully:", data);
        } else {
          const errorData = await response.text();
          console.error("[ERROR] Error removing accessory:", errorData);
        }
      } catch (error) {
        console.error("[ERROR] Error during accessory removal fetch:", error);
      }
    }
  };

  const handleAddAccessories = () => {
    console.log("[INFO] Navigating to Add Accessories page");
    navigate("/Admin/ComputerAccessories");
  };

  const handleSaveAccessories = async () => {
    // if (selectedAccessories.length === 0) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "No Accessories Selected",
    //     text: "Please select at least one accessory to update.",
    //     confirmButtonColor: "#ff9800",
    //   });
    //   return; // Prevent saving when no accessories are selected
    // }

    console.log("[INFO] Saving selected accessories");
    const payload = {
      id: currentProductId,
      accessoryIds: selectedAccessories.join(","),
    };
    console.log("[INFO] Payload for saving accessories:", payload);

    try {
      const response = await fetch(`${ApiUrl}/addfrequentlybuy`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const data = await response.text();
        console.log("[INFO] Accessories updated successfully:", data);

        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: "success",
          // title: "Success",
          text: "Accessories have been updated successfully!",
          confirmButtonColor: "#4caf50",
          showConfirmButton: false,
          timer: 4000
        });
      } else {
        const errorData = await response.text();
        console.error("[ERROR] Failed to update accessories:", errorData);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to update accessories. Please try again.",
          confirmButtonColor: "#f44336",
        });
      }
    } catch (error) {
      console.error("[ERROR] Unexpected error during save operation:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An unexpected error occurred. Please try again later.",
        confirmButtonColor: "#f44336",
      });
    }

    setIsFrequentlyBuyModalOpen(false);
    setSelectedAccessories([]);
  };

  const role = localStorage.getItem("userRole"); // Assuming user role is stored as "admin" or "user"

  const handleCopyProduct = async (productId) => {
    try {
      const response = await fetch(`${ApiUrl}/api/copy-product/${productId}`, {
        method: "POST",
      });

      const data = await response.json();
      if (response.ok) {
        // Success alert using SweetAlert
        Swal.fire({
          title: "Success!",
          text: `Product copied successfully! New product ID: ${data.newProductId}`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          // After the alert closes, call the fetchProducts function
          window.location.reload();
        });
      } else {
        // Error alert using SweetAlert
        Swal.fire({
          title: "Error!",
          text: data.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error copying product:", error);
      // Generic error alert using SweetAlert
      Swal.fire({
        title: "Oops!",
        text: "Something went wrong. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // Compute stats
  const totalProducts = products.length;

  const inStock = products.filter(p => p.status !== "unavailable").length;
  const outOfStock = totalProducts - inStock;

  const withCoupons = products.filter(p => couponProducts[p.id]?.hasCoupon).length;
  const withAccessories = products.filter(p => accessoryCounts[p.id] > 0).length;
  // Calculate price with margin
  const getMarginAppliedPrice = (product) => {
    const basePrice = Number(
      product.offer_price > 0 && isOfferActive
        ? product.offer_price
        : product.prod_price
    );

    if (userRole === "admin") return { finalPrice: basePrice, marginAdded: 0 };

    // find matching rule
    const rule = margin.find(
      (m) => basePrice >= m.range_from && basePrice <= m.range_to
    );

    const marginAdded = rule ? Number(rule.margin_amount) : 0;
    const finalPrice = basePrice + marginAdded;

    return { finalPrice, marginAdded };
  };

  return (
    <div className="laptops-page">
      <div className="laptops-content">
        <h2 className="laptops-page-title">Add Computers</h2>
        <div className="laptops-form-container">
          {/* Left Section */}
          <div className="laptops-left-section">
            <label className="laptops-label">Product Name</label>
            <input
              type="text"
              name="name"
              value={newProduct.name}
              onChange={handleChange}
              className="laptops-input"
            />
            <label className="laptops-label">M.R.P Price</label>
            <input
              type="text"
              name="actual_price"
              value={newProduct.actual_price}
              onChange={handleChange}
              className="laptops-input"
            />
            <label className="laptops-label">Selling Price</label>
            <input
              type="text"
              name="price"
              value={newProduct.price}
              onChange={handleChange}
              className="laptops-input"
            />
            <label className="laptops-label">Label</label>
            <input
              type="text"
              name="label"
              value={newProduct.label}
              onChange={handleChange}
              className="laptops-input"
            />
            <label className="laptops-label">Subtitle</label>
            <input
              type="text"
              name="subtitle"
              value={newProduct.subtitle}
              onChange={handleChange}
              className="laptops-input"
            />
            <label className="laptops-label">Delivery Charge</label>
            <input
              type="text"
              name="deliverycharge"
              value={newProduct.deliverycharge}
              onChange={handleChange}
              className="laptops-input"
            />
            <label className="laptops-label">Product Image</label>
            <input
              accept="image/jpeg, image/png, image/webp"
              ref={fileInputRef}
              multiple
              onChange={handleImageChange}
              style={{ display: "none" }}
              type="file"
              className="laptops-file-input"
            />
            <button
              type="button"
              onClick={() => fileInputRef.current.click()}
              className="custom-file-input-button"
            >
              <FaImages className="file-icon" />
              {imageCount > 0
                ? `Selected Images: ${imageCount}`
                : "Choose Images"}
            </button>{" "}
          </div>

          {/* Right Section */}
          <div className="laptops-right-section">
            <label className="laptops-label">RAM</label>
            <input
              type="text"
              name="memory"
              value={newProduct.memory}
              onChange={handleChange}
              className="laptops-input"
            />

            <label className="laptops-label">ROM</label>
            <input
              type="text"
              name="storage"
              value={newProduct.storage}
              onChange={handleChange}
              className="laptops-input"
            />

            <label className="laptops-label">Processor</label>
            <input
              type="text"
              name="processor"
              value={newProduct.processor}
              onChange={handleChange}
              className="laptops-input"
            />

            <label className="laptops-label">Display</label>
            <input
              type="text"
              name="display"
              value={newProduct.display}
              onChange={handleChange}
              className="laptops-input"
            />

            <label className="laptops-label">Operating System</label>
            <input
              type="text"
              name="os"
              value={newProduct.os}
              onChange={handleChange}
              className="laptops-input"
            />

            <label className="laptops-label">Other Details</label>
            <textarea
              name="others"
              value={newProduct.others}
              onChange={handleChange}
              className="laptops-textarea"
            ></textarea>

            <button
              onClick={() => handleAddProduct(newProduct)}
              className="laptops-add-btn"
            >
              Add
            </button>
          </div>
        </div>
        <hr className="dotted-divider" />
        <h2 className="laptops-page-title">Computer Product List</h2>

        {(totalProducts > 0 || inStock > 0 || outOfStock > 0 || withCoupons > 0 || withAccessories > 0) && (
          <>
            <div className="laptops-summary-stats-row">
              <div className="laptops-stat-card">
                <h5>Total Products</h5>
                <p>{totalProducts}</p>
              </div>
              <div className="laptops-stat-card">
                <h5>In Stock </h5>
                <p>{inStock}</p>
              </div>
              <div className="laptops-stat-card">
                <h5>Out of Stock </h5>
                <p>{outOfStock}</p>
              </div>
              <div className="laptops-stat-card">
                <h5>With Coupons 🎟️</h5>
                <p>{withCoupons}</p>
              </div>
              <div className="laptops-stat-card">
                <h5>With Accessories</h5>
                <p>{withAccessories}</p>
              </div>
            </div>


            <div className="filters-card">
              <div className="filters-panel">
                <div className="filter-label-title">
                  <img src={FilterIcon} width={"20px"} alt="Filter" />

                  <span> Filter By </span>
                  {/* <FilterIcon width={"20px"}/> */}
                </div>
                <label className="filter-label">
                  <input
                    type="checkbox"
                    checked={showOutOfStockOnly}
                    onChange={() => setShowOutOfStockOnly(!showOutOfStockOnly)}
                  />
                  Out of Stock
                </label>

                <label className="filter-label">
                  <input
                    type="checkbox"
                    checked={showHasCouponOnly}
                    onChange={() => setShowHasCouponOnly(!showHasCouponOnly)}
                  />
                  Coupon
                </label>

                <label className="filter-label">
                  <input
                    type="checkbox"
                    checked={showHasAccessoriesOnly}
                    onChange={() => setShowHasAccessoriesOnly(!showHasAccessoriesOnly)}
                  />
                  Frequently Bought Accessories
                </label>

                <div className="filter-search-wrapper">
                  <SearchIcon width={'18px'} className="search-icon-btn" />
                  {/* <img src={SearchIcon} width={'20px'}/> */}
                  <input
                    type="text"
                    placeholder="Search by name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="filter-input"
                  />
                  {searchTerm && (
                    <button
                      className="filter-clear-btn"
                      onClick={() => setSearchTerm("")}
                      aria-label="Clear search"
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>
            </div>
          </>
        )}


        <div className="laptops-products-list">
          {products.length === 0 ? (
            <div className="empty-state-message"><FaInfoCircle /> No products available. Please add some Computer products.</div>
          ) : (
            (() => {
              const filteredProducts = products
                .filter((product) =>
                  product.prod_name.toLowerCase().includes(searchTerm.toLowerCase())
                )

                .filter((product) =>
                  showOutOfStockOnly ? product.status === "unavailable" : true
                )
                .filter((product) =>
                  showHasCouponOnly ? couponProducts[product.id]?.hasCoupon : true
                )
                .filter((product) =>
                  showHasAccessoriesOnly ? accessoryCounts[product.id] > 0 : true
                );
              return filteredProducts.length === 0 ? (
                <div className="empty-state-message"><FaInfoCircle /> No products match your filters.</div>
              ) : (
                filteredProducts
                  .map((product, index) => (
                    <div className="laptops-product-card" key={product.id}>
                      {product.status === "unavailable" && (
                        <span className="out_of_stock_ribbon"></span>
                      )}

                      {product.offer_label && (
                        <div className="product-label">{product.offer_label}</div>
                      )}

                      {/* Display product image */}
                      <div className="laptops-product-image">
                        <div className="slider-container">
                          <Slider
                            {...{
                              ...settings,
                              arrows: product.prod_img.length > 1,
                              draggable: product.prod_img.length > 1, // Disable dragging if only one image exists
                              swipe: product.prod_img.length > 1, // Disable swipe gestures on touch devices for one image
                            }}
                          >
                            {product.prod_img.map((img, imgIndex) => (
                              <div key={imgIndex} className="image-wrapper">
                                <img
                                  src={`${ApiUrl}/uploads/computers/${img}`}
                                  alt={product.prod_name}
                                  className="laptops-product-image"
                                  onClick={() =>
                                    handleImageClick(
                                      imgIndex, // Index of the clicked image in this product
                                      product.prod_img.map(img => `${ApiUrl}/uploads/computers/${img}`) // Only current product's images
                                    )
                                  }

                                />

                                <div className="image-actions">
                                  <FaEdit
                                    title="Update this image"
                                    onClick={() => openModal(product.id, imgIndex)} // Pass product ID and image index
                                    className="action-icon"
                                  />
                                  {product.prod_img.length > 1 && ( // Display trash icon only if there is more than one image
                                    <FaTrash
                                      title="Delete this image"
                                      onClick={() =>
                                        handleDeleteImage(product.id, imgIndex)
                                      }
                                      className="action-icon"
                                    />
                                  )}
                                </div>
                              </div>
                            ))}
                          </Slider>
                        </div>
                      </div>


                      {/* Display product name */}
                      <div className="laptops-product-details">
                        <h3 className="laptops-product-name" title={product.prod_name}>
                          {product.prod_name}
                        </h3>

                        {product.productStatus === "unapproved" && (
                          <>
                            <img
                              src={userRole === "Admin" ? ApproveImage : ApprovalWaitingImage}
                              title={userRole === "Admin" ? "Click to approve this product" : "Product yet not approved(Contact Admin)"}
                              width={userRole === "Admin" ? "50px" : "60px"}
                              style={{
                                cursor: userRole === "Admin" ? "pointer" : "not-allowed",
                              }}
                              onClick={
                                userRole === "Admin"
                                  ? () => handleStatusUpdate(product.prod_id) //  Only for Admin
                                  : undefined //  Disabled for non-admin
                              }
                              alt="role"
                            />
                          </>
                        )}

                      </div>

                      <div>
                        M.R.P{" "}
                        <span
                          style={{
                            textDecoration: "line-through",
                            color: "red",
                            fontSize: "14px",
                          }}
                        >
                          ₹{product.actual_price}
                        </span>{" "}



                        <span className="product-price">
                          {(() => {
                            const basePrice =
                              product.offer_price > 0 && isOfferActive
                                ? product.offer_price
                                : product.prod_price;

                            const { finalPrice, marginAdded } = getMarginAppliedPrice(product);

                            // NON-ADMIN → only base price
                            if (userRole !== "Admin") {
                              return <>₹{basePrice}</>;
                            }

                            // ADMIN → final price + margin badge
                            return (
                              <>
                                ₹{finalPrice}

                                {marginAdded > 0 && (
                                   <span className="margin-badge">
                                   ₹{basePrice} +
                                   <br/>
                                   ₹{marginAdded} margin
                                  </span>
                                )}
                              </>
                            );
                          })()}
                        </span>





                      </div>
                      {/* <>{product.prod_id}</> */}


                      {/* {product.offer_price > 0 && (
                  <div>Limited Time Offer
                    <span style={{ color: "blue", marginLeft: "5px" }}>
                      ₹{product.offer_price}
                    </span></div>
                  )} */}

                      <div className="product-extras">
                        {couponProducts[product.id]?.hasCoupon && (
                          <div className="coupon-wrapper">
                            <div className="coupon-image-wrapper">
                              {couponProducts[product.id].isExpired === true ?
                                <img
                                  onClick={() =>
                                    fetchCoupons(
                                      product.prod_id,
                                      product.prod_name,
                                      product.prod_price
                                    )
                                  }
                                  src={ExpiredCouponImage}
                                  width="35px"
                                  alt="Coupon"
                                  className="coupon-image"
                                />
                                :
                                <img
                                  onClick={() =>
                                    fetchCoupons(
                                      product.prod_id,
                                      product.prod_name,
                                      product.prod_price
                                    )
                                  }
                                  src={ActiveCouponImage}
                                  width="35px"
                                  alt="Coupon"
                                  className="coupon-image"
                                />
                              }
                              {/* <span
                          className={
                            couponProducts[product.id].isExpired === true
                              ? "coupon-status-dot red-dot"
                              : "coupon-status-dot green-dot"
                          }
                        /> */}
                              <span

                                className="tooltip-text">
                                {couponProducts[product.id].isExpired ? "Coupon Expired" : "Coupon is active"}
                              </span>
                            </div>
                          </div>
                        )}


                        <button
                          className="view-details-btn"
                          title="View more details"
                          onClick={() => openProductModal(product.id)} // Pass product ID to open modal
                        >
                          <FaEye /> View
                        </button>

                        {accessoryCounts[product.id] > 0 && (
                          <div className="accessory-count-wrapper">
                            <span className="accessory-count">
                              {/* {accessoryCounts[product.id]} FA */}
                              <img src={AccessoriesImage} width={"60px"} alt="accessories"
                                onClick={() =>
                                  handleOpenFrequentlyBuyModal(
                                    product.id,
                                    product.category
                                  )
                                }
                              />
                              <span className="tooltip-text">Frequently buy accessories</span>
                            </span>
                          </div>
                        )}

                      </div>

                      <div className="laptops-product-actions">
                        <button
                          onClick={() => handleEditProduct(product)}
                          className="laptops-action-btn"
                          title="Update this product"
                        >
                          <FaEdit /> Edit
                        </button>
                        <button
                          onClick={() => handleDeleteProduct(product.id)}
                          className="laptops-action-btn"
                          title="Delete this product"
                        >
                          <FaTrash /> Delete
                        </button>
                      </div>

                      {/* Modal for displaying product details */}
                      {isModalOpen2 && modalProductId === product.id && (
                        <div className="product-details-modal">
                          <div className="modal-overlay">
                            <div className="modal-content">
                              <button
                                onClick={closeProductModal}
                                className="modal-close-btn"
                              >
                                &times; {/* Close button */}
                              </button>
                              <div className="laptops-modal-form-container">
                                {/* <h3 className="modal-title">{product.prod_name}</h3> */}

                                <div className="laptops-modal-content">
                                  <div className="laptops-modal-left-section">
                                    <p>
                                      <strong>Product Name</strong>
                                      <span>{product.prod_name}</span>
                                    </p>
                                    <p>
                                      <strong>Subtitle</strong>
                                      <span>{product.subtitle}</span>
                                    </p>
                                    <p>
                                      <strong>M.R.P Price</strong>
                                      <span>₹{product.actual_price}</span>
                                    </p>

                                    <p>
                                      <strong>Selling Price</strong>
                                      <span>₹{product.prod_price}</span>
                                    </p>
                                    <p>
                                      <strong>Delivery charge</strong>
                                      <span>₹{product.deliverycharge}</span>
                                    </p>
                                    <p>
                                      <strong>RAM</strong>
                                      <span>{product.memory} </span>
                                    </p>
                                    <p>
                                      <strong>ROM</strong>
                                      <span>{product.storage} </span>
                                    </p>
                                    <p>
                                      <strong>Processor</strong>
                                      <span>{product.processor}</span>
                                    </p>
                                    <p>
                                      <strong>OS</strong>
                                      <span>{product.os}</span>
                                    </p>
                                    <p>
                                      <strong>Display</strong>
                                      <span>{product.display}</span>
                                    </p>
                                    <p>
                                      <strong>Other features</strong>
                                      <span>{product.others}</span>
                                    </p>
                                    <div className="laptops-product-actions">
                                      <button
                                        onClick={() => handleEditProduct(product)}
                                        className="laptops-action-btn"
                                      >
                                        <FaEdit /> Edit
                                      </button>
                                      <button
                                        onClick={() =>
                                          handleDeleteProduct(product.id)
                                        }
                                        className="laptops-action-btn"
                                      >
                                        <FaTrash /> Delete
                                      </button>
                                    </div>
                                  </div>

                                  <div className="laptops-modal-right-section">
                                    {product.status === "available" &&
                                      <div
                                        onClick={() => handleOpenOfferModal(product.id)}
                                        className="offer-edit-btn"
                                      >
                                        <span className="offer-edit-text">
                                          Edit Limited Time Offer
                                        </span>
                                        <FaEdit className="offer-edit-icon" />
                                      </div>
                                    }

                                    {/* Modal Rendering */}
                                    {isOfferModalOpen && (
                                      <div className="offer-modal-overlay">
                                        <div className="offer-modal-content">
                                          <button
                                            onClick={handleCloseOfferModal}
                                            className="offer-close-btn"
                                          >
                                            &times;
                                          </button>
                                          <h3 className="offer-modal-title">
                                            {isEditMode
                                              ? "Edit Limited Time Price Offer"
                                              : "Add Limited Time Price Offer"}
                                          </h3>
                                          <form
                                            onSubmit={handleSubmit}
                                            className="offer-form"
                                          >
                                            <label className="offer-label">
                                              Offer Start Time
                                            </label>
                                            <input
                                              type="datetime-local"
                                              value={offerStartTime}
                                              onChange={(e) =>
                                                setOfferStartTime(e.target.value)
                                              }
                                              required
                                              min={minDate}
                                              className="offer-input"
                                            />
                                            <label className="offer-label">
                                              Offer End Time
                                            </label>
                                            <input
                                              type="datetime-local"
                                              value={offerEndTime}
                                              onChange={(e) =>
                                                setOfferEndTime(e.target.value)
                                              }
                                              required
                                              min={offerStartTime || minDate} // End date cannot be before start date
                                              max={
                                                offerStartTime
                                                  ? getFormattedDate(
                                                    new Date(
                                                      new Date(
                                                        offerStartTime
                                                      ).getTime() +
                                                      10 * 86400000
                                                    )
                                                  )
                                                  : maxDate
                                              } // Max 10 days from start
                                              className="offer-input"
                                            />
                                            <label className="offer-label">
                                              Offer Price
                                            </label>
                                            <input
                                              type="number"
                                              value={offerPrice}
                                              onChange={(e) =>
                                                handleChangePrice(
                                                  e,
                                                  product.prod_price
                                                )
                                              } // Pass product.prod_price
                                              required
                                              className="offer-input"
                                            />
                                            <button
                                              type="submit"
                                              className="offer-submit-btn"
                                            >
                                              {isEditMode && offerStartTime && offerEndTime && offerPrice
                                                ? "Update Offer"
                                                : "Add Offer"
                                              }
                                            </button>
                                          </form>

                                          {isEditMode && offerStartTime && offerEndTime && offerPrice && (
                                            <button
                                              onClick={handleDelete}
                                              className="offer-delete-btn"
                                            >
                                              Delete Offer
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    )}

                                    {/* Upload Section */}
                                    <div className="upload-container">
                                      Upload more images
                                      <input
                                        style={{ marginTop: "10px" }}
                                        className="file-input"
                                        multiple
                                        type="file"
                                        onChange={(e) =>
                                          handleFileChange(product.id, e)
                                        }
                                      />
                                      <button
                                        className="upload-button"
                                        onClick={() => handleUploadImages(product.id)}
                                      >
                                        Upload Images
                                      </button>
                                    </div>

                                    {/* Coupon Section */}
                                    <p className="laptops-product-coupon">
                                      Coupon Code:
                                      <span
                                        onClick={() =>
                                          openPopup(
                                            product.prod_id,
                                            product.prod_name,
                                            product.prod_price
                                          )
                                        }
                                        style={{ cursor: "pointer" }}
                                      >
                                        <FaPlusCircle
                                          className="faedit"
                                          title="Add Coupon"
                                        />
                                      </span>
                                      <span
                                        onClick={() => {
                                          setIsModalOpen2(false);
                                          fetchCoupons(
                                            product.prod_id,
                                            product.prod_name,
                                            product.prod_price
                                          );
                                        }
                                        }
                                        style={{ cursor: "pointer" }}
                                      >
                                        {couponProducts[product.id]?.hasCoupon && (
                                          <FaEye
                                            className="faedit"
                                            title="View Coupon"
                                          />
                                        )}
                                      </span>
                                    </p>

                                    <CouponEditPopup
                                      isOpen={isPopupOpen}
                                      onClose={closePopup}
                                      productId={selectedProductId}
                                      prodPrice={selectedProductPrice}
                                      onCouponUpdated={handleCouponUpdated}
                                    />



                                    {/* Frequently Buy Section */}
                                    <div
                                      className="frequently-buy"
                                      style={{ marginBottom: "10px" }}
                                    >
                                      <span className="frequently-buy-label">
                                        Make a copy of this product
                                      </span>
                                      <FaClone
                                        onClick={() => handleCopyProduct(product.id)}
                                        className="copy-icon"
                                      />
                                    </div>

                                    <div className="frequently-buy">
                                      <span className="frequently-buy-label">
                                        Frequently Buy Products
                                      </span>
                                      <FaPlusCircle
                                        className="frequently-buy-icon"
                                        onClick={() => {
                                          handleOpenFrequentlyBuyModal(
                                            product.id,
                                            product.category
                                          );
                                          setIsModalOpen2(false)
                                        }
                                        }
                                      />
                                    </div>

                                    <div
                                      className={`${product.status === "available" ? "In-stock" : "Out-of-stock"
                                        } status-container`}
                                    >
                                      <div className="dropdown-wrapper">
                                        <select
                                          className="status-dropdown"
                                          value={product.status}
                                          onChange={(e) =>
                                            handleStatusChange(
                                              e.target.value, // New status
                                              product.id      // Product ID
                                            )
                                          }
                                        >
                                          <option value="available">In Stock</option>
                                          <option value="unavailable">Out of Stock</option>
                                        </select>
                                        <FaChevronDown className="select-dropdown-arrow" />
                                      </div>
                                    </div>


                                    {/* <span>&#9662;</span> */}

                                    {/* {isFrequentlyBuyModalOpen && (
                                      <div className="freq-modal-overlay">
                                        <div className="freq-modal-content">
                                          <button
                                            onClick={handleCloseFrequentlyBuyModal}
                                            className="freq-modal-close-btn"
                                          >
                                            <FaTimes />
                                          </button>
                                          <h3 className="freq-modal-title">
                                            Select Accessories
                                          </h3>
                                          {Array.isArray(computerAccessories) &&
                                            computerAccessories.length === 0 ? (
                                            <div className="no-accessories-message">
                                              <p>
                                                No accessories added to this category
                                              </p>
                                              <button
                                                onClick={handleAddAccessories}
                                                className="add-accessories-btn"
                                              >
                                                Add Accessories
                                              </button>
                                            </div>
                                          ) : (
                                            <div className="freq-modal-list">
                                              {Array.isArray(computerAccessories) &&
                                                computerAccessories.map(
                                                  (accessory) => {
                                                    const images = Array.isArray(
                                                      accessory.prod_img
                                                    )
                                                      ? accessory.prod_img
                                                      : JSON.parse(
                                                        accessory.prod_img || "[]"
                                                      );
                                                    const firstImage = images[0];

                                                    return (
                                                      <div
                                                        key={accessory.id}
                                                        className="freq-modal-item"
                                                      >
                                                        <div className="freq-image-wrapper">
                                                          {firstImage && (
                                                            <img
                                                              src={`${ApiUrl}/uploads/computeraccessories/${firstImage}`}
                                                              alt={
                                                                accessory.prod_name
                                                              }
                                                              className="freq-item-image"
                                                            />
                                                          )}
                                                        </div>
                                                        <div className="freq-item-details">
                                                          <span className="freq-item-name">
                                                            {accessory.prod_name
                                                              .split(" ")
                                                              .slice(0, 4)
                                                              .join(" ")}
                                                          </span>
                                                          <span className="freq-item-price">
                                                            ₹{accessory.effectiveprice}
                                                          </span>
                                                        </div>
                                                        <input
                                                          type="checkbox"
                                                          className="freq-item-checkbox"
                                                          value={accessory.id}
                                                          checked={selectedAccessories.includes(
                                                            accessory.id.toString()
                                                          )}
                                                          onChange={
                                                            handleAccessorySelection
                                                          }
                                                        />
                                                      </div>
                                                    );
                                                  }
                                                )}
                                            </div>
                                          )}
                                          {Array.isArray(computerAccessories) &&
                                            computerAccessories.length > 0 && (
                                              <button
                                                onClick={handleSaveAccessories}
                                                className="freq-save-btn"
                                              >
                                                Add
                                              </button>
                                            )}
                                        </div>
                                      </div>
                                    )} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      <EditCouponModal
                        isOpen={isEditingCoupon}
                        onClose={() => setIsEditingCoupon(false)}
                        coupon={selectedCoupon}
                        productId={selectedProductId}
                        productPrice={selectedProductPrice}
                        onCouponUpdated={() => { }}
                      />


                      {isViewingCoupons && (
                        <div className="pop-overlay">
                          <div className="pop-content">
                            <button
                              onClick={() => setIsViewingCoupons(false)}
                              className="fatimes"
                            >
                              <FaTimes color="black" size={20} />
                            </button>
                            <h4>Coupon list for this product</h4>
                            <span className="coupon-title-with-image">
                              {product.prod_img?.[0] && (
                                <img
                                  src={`${ApiUrl}/uploads/computers/${product.prod_img[0]}`}
                                  alt={product.prod_name}
                                  className="coupon-product-image"
                                />
                              )}
                              <span className="coupon-product-name">
                                {productName}
                              </span>
                            </span>

                            {coupons.length > 0 ? (
                              <div className="coupons-wrapper">
                                {/* Active Coupons */}
                                {coupons.filter(coupon => {
                                  const couponDate = new Date(coupon.expiry_date);
                                  const today = new Date();
                                  // Normalize both dates to midnight (ignore time zone)
                                  couponDate.setHours(0, 0, 0, 0);
                                  today.setHours(0, 0, 0, 0);
                                  return couponDate >= today;
                                }).length > 0 && (
                                    <div className="active-coupons-box">
                                      <h5>Active Coupons</h5>
                                      <ul className="coupons-list active-list">
                                        {coupons
                                          .filter(coupon => {
                                            const couponDate = new Date(coupon.expiry_date);
                                            const today = new Date();
                                            couponDate.setHours(0, 0, 0, 0);
                                            today.setHours(0, 0, 0, 0);
                                            return couponDate >= today;
                                          })
                                          .map((coupon, index) => (
                                            <li key={coupon.coupon_id} className="coupon-item">
                                              <span className="serial-number">{index + 1}. </span>
                                              <span className="coupon-code">{coupon.coupon_code}</span> -
                                              <span className="coupon-code">{coupon.discount_value}</span> -
                                              <span className="expiry-date">
                                                {new Date(coupon.expiry_date).toLocaleDateString("en-GB", {
                                                  day: "2-digit",
                                                  month: "short",
                                                  year: "numeric",
                                                })}
                                              </span>
                                              <FaEdit
                                                className="edit-icon"
                                                title="Edit Expiry Date"
                                                onClick={() => {
                                                  handleEditExpiry(coupon.coupon_id);
                                                  setIsViewingCoupons(false);
                                                }}
                                              />
                                              <FaTrash
                                                className="delete-icon"
                                                title="Delete Coupon"
                                                onClick={() => handleDeleteCoupon(coupon.coupon_id)}
                                                style={{
                                                  marginLeft: "10px",
                                                  cursor: "pointer",
                                                }}
                                              />
                                            </li>
                                          ))}
                                      </ul>
                                    </div>
                                  )}

                                {/* Expired Coupons */}
                                {coupons.filter(coupon => {
                                  const couponDate = new Date(coupon.expiry_date);
                                  const today = new Date();
                                  // Normalize both dates
                                  couponDate.setHours(0, 0, 0, 0);
                                  today.setHours(0, 0, 0, 0);
                                  return couponDate < today;
                                }).length > 0 && (
                                    <div className="expired-coupons-box">
                                      <h5>Expired Coupons</h5>
                                      <ul className="coupons-list expired-list">
                                        {coupons
                                          .filter(coupon => {
                                            const couponDate = new Date(coupon.expiry_date);
                                            const today = new Date();
                                            couponDate.setHours(0, 0, 0, 0);
                                            today.setHours(0, 0, 0, 0);
                                            return couponDate < today;
                                          })
                                          .map((coupon, index) => (
                                            <li key={coupon.coupon_id} className="coupon-item">
                                              <span className="serial-number">{index + 1}. </span>
                                              <span className="coupon-code">{coupon.coupon_code}</span> -
                                              <span className="coupon-code">{coupon.discount_value}</span> -
                                              <span className="expiry-date">
                                                {new Date(coupon.expiry_date).toLocaleDateString("en-GB", {
                                                  day: "2-digit",
                                                  month: "short",
                                                  year: "numeric",
                                                })}
                                              </span>
                                              <FaEdit
                                                className="edit-icon"
                                                title="Edit Expiry Date"
                                                onClick={() => {
                                                  handleEditExpiry(coupon.coupon_id);
                                                  setIsViewingCoupons(false);
                                                }}
                                              />
                                              <FaTrash
                                                className="delete-icon"
                                                title="Delete Coupon"
                                                onClick={() => handleDeleteCoupon(coupon.coupon_id)}
                                                style={{
                                                  marginLeft: "10px",
                                                  cursor: "pointer",
                                                }}
                                              />
                                            </li>
                                          ))}
                                      </ul>
                                    </div>
                                  )}
                              </div>
                            ) : (
                              <p>No coupons available for this product.</p>
                            )}

                          </div>
                        </div>
                      )}

                      {isFrequentlyBuyModalOpen && (
                        <div className="freq-modal-overlay">
                          <div className="freq-modal-content">
                            <button
                              onClick={handleCloseFrequentlyBuyModal}
                              className="freq-modal-close-btn"
                            >
                              <FaTimes />
                            </button>
                            <h3 className="freq-modal-title">
                              Select Accessories
                            </h3>
                            {Array.isArray(computerAccessories) &&
                              computerAccessories.length === 0 ? (
                              <div className="no-accessories-message">
                                <p>
                                  No accessories added to this category
                                </p>
                                <button
                                  onClick={handleAddAccessories}
                                  className="add-accessories-btn"
                                >
                                  Add Accessories
                                </button>
                              </div>
                            ) : (
                              <div className="freq-modal-list">
                                {Array.isArray(computerAccessories) &&
                                  computerAccessories.map(
                                    (accessory) => {
                                      const images = Array.isArray(
                                        accessory.prod_img
                                      )
                                        ? accessory.prod_img
                                        : JSON.parse(
                                          accessory.prod_img || "[]"
                                        );
                                      const firstImage = images[0];

                                      return (
                                        <div
                                          key={accessory.id}
                                          className="freq-modal-item"
                                        >
                                          <div className="freq-image-wrapper">
                                            {firstImage && (
                                              <img
                                                src={`${ApiUrl}/uploads/computeraccessories/${firstImage}`}
                                                alt={
                                                  accessory.prod_name
                                                }
                                                className="freq-item-image"
                                              />
                                            )}
                                          </div>
                                          <div className="freq-item-details">
                                            <span className="freq-item-name">
                                              {accessory.prod_name
                                                .split(" ")
                                                .slice(0, 4)
                                                .join(" ")}                                                    </span>
                                            <span className="freq-item-price">
                                              ₹{accessory.prod_price}
                                            </span>
                                          </div>
                                          <input
                                            type="checkbox"
                                            className="freq-item-checkbox"
                                            value={accessory.id}
                                            checked={selectedAccessories.includes(
                                              accessory.id.toString()
                                            )}
                                            onChange={
                                              handleAccessorySelection
                                            }
                                          />
                                        </div>
                                      );
                                    }
                                  )}
                              </div>
                            )}
                            {Array.isArray(computerAccessories) &&
                              computerAccessories.length > 0 && (
                                <button
                                  onClick={handleSaveAccessories}
                                  className="freq-save-btn"
                                >
                                  Add
                                </button>
                              )}
                          </div>
                        </div>
                      )}
                    </div>
                  ))
              );
            })()
          )}
        </div>
      </div>


      {/* <table className="product-table">
        <thead> 
          <tr>
            <th>Image</th>
            <th>Name</th>
            <th>Price</th>
            <th>M.R.P</th>
            <th>View</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
        {products.map((product) => {
  const images = Array.isArray(product.prod_img)
    ? product.prod_img
    : JSON.parse(product.prod_img || "[]");

  const firstImage = images[0];

  return (
    <tr key={product.id}>
      <td className="product-image-cell">
        {firstImage ? (
          <>
            <img
              src={`${ApiUrl}/uploads/computers/${firstImage}`}
              alt={product.prod_name}
              onClick={() =>
                handleImageClick(
                  0, 
                  images.map((img) => `${ApiUrl}/uploads/computers/${img}`),
                  product.id // pass the product ID
                )
              }
              style={{
                width: "80px",
                height: "auto",
                cursor: "pointer",
              }}
            />
           
          </>
        ) : (
          "No Image"
        )}
      </td>

                <td className="product-name-cell">
                  {product.prod_name.split(" ").slice(0, 4).join(" ") +
                    (product.prod_name.split(" ").length > 4 ? "..." : "")}
                </td>
                <td className="product-price-cell">₹{product.prod_price}</td>
                <td className="product-actual-price-cell">
                  <span
                    style={{ textDecoration: "line-through", color: "red" }}
                  >
                    ₹{product.actual_price}
                  </span>
                </td>
                <td className="product-edit-btn-cell">
                  <button
                    onClick={() => openProductModal(product.id)}
                    className="table-btn edit"
                  >
                    <FaEye />
                  </button>
                </td>
                <td className="product-edit-btn-cell">
                  <button
                    onClick={() => handleEditProduct(product)}
                    className="table-btn edit"
                  >
                    <FaEdit />
                  </button>
                </td>
                <td className="product-delete-btn-cell">
                  <button
                    onClick={() => handleDeleteProduct(product.id)}
                    className="table-btn delete"
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Lightbox
  open={isOpen}
  close={() => setIsOpen(false)}
  index={photoIndex}
  slides={lightboxImages.map((src) => ({ src }))}
  on={{
    view: ({ index }) => setPhotoIndex(index),
    close: () => setIsOpen(false),
  }}
  carousel={{
    finite: true,
    preload: lightboxImages.length > 1 ? 2 : 0,
    padding: 0,
    spacing: 0,
    swipe: lightboxImages.length > 1, // 👈 disable swipe if only one image
  }}
  render={{
    slide: ({ slide }) => (
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        <div
          style={{
            position: "absolute",
            top: "50px",
            right: "20px",
            zIndex: 9999,
            display: "flex",
            gap: "16px",
            backgroundColor: "rgba(83, 15, 15, 0.8)",
            padding: "6px 10px",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          }}
        >
          <FaEdit
            onClick={() => {
              openModal(currentProductId, photoIndex);
              setIsOpen(false);
            }}
            style={{ cursor: "pointer", fontSize: "22px", color: "#007bff" }}
          />
          {lightboxImages.length > 1 && (
            <FaTrash
              onClick={() => {
                handleDeleteImage(currentProductId, photoIndex);
                setIsOpen(false);
              }}
              style={{ cursor: "pointer", fontSize: "22px", color: "#dc3545" }}
            />
          )}
        </div>

        <img
          src={slide.src}
          alt=""
          draggable={false}
          style={{
            maxHeight: "90vh",
            maxWidth: "100%",
            margin: "0 auto",
            display: "block",
            objectFit: "contain",
            paddingTop: "100px",
          }}
        />
      </div>
    ),
  }}
/> */}



      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
        style={{ overlay: overlayStyle, content: modalStyle }} // Apply inline styles
      >
        <h2 style={titleStyle}>Update this image</h2>
        <input
          type="file"
          accept="image/jpeg, image/png, image/webp"
          onChange={handleImageUpload} // Keep this function for handling file selection
          style={inputStyle}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <button
            onClick={() => handleImageUpdate(productId)} // Use the product ID here
            style={buttonStyle}
            onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor =
              buttonHoverStyle.backgroundColor)
            } // Hover effect
            onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor =
              buttonStyle.backgroundColor)
            } // Reset color
          >
            Update
          </button>

          <button
            onClick={closeModal}
            style={buttonStyle}
            onMouseOver={(e) =>
            (e.currentTarget.style.backgroundColor =
              buttonHoverStyle.backgroundColor)
            } // Hover effect
            onMouseOut={(e) =>
            (e.currentTarget.style.backgroundColor =
              buttonStyle.backgroundColor)
            } // Reset color
          >
            Close
          </button>
        </div>
      </Modal>

      {isOpen && (
        // Sample usage
        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          slides={lightboxImages.map((src) => ({ src }))}
          index={photoIndex}
          on={{ view: ({ index }) => setPhotoIndex(index) }}
          carousel={{ finite: true }}

        />
      )}


      {editingProduct && (
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setModalIsOpen(false)}
          contentLabel="Edit Product"
          className="adminmodal6"
          overlayClassName="adminmodal-overlay"
        >
          <div className="adminmodal-header">
            <h2>Edit Product</h2>
            <button
              onClick={() => setModalIsOpen(false)}
              className="adminmodal-close-btn"
            >
              &times;
            </button>
          </div>

          <div className="adminmodal-body">
            <div className="part1">
              {/* Part 1 fields */}
              <div className="feature-item">
                <label className="feature-label">Name</label>

                <input
                  type="text"
                  name="name"
                  value={editingProduct.name}
                  onChange={(e) =>
                    setEditingProduct({
                      ...editingProduct,
                      name: e.target.value,
                    })
                  }
                  placeholder="Enter product name"
                  className="adminmodal-input"
                />
              </div>

              <div className="feature-item">
                <label className="feature-label">Subtitle</label>
                <input
                  type="text"
                  name="subtitle"
                  value={editingProduct.subtitle}
                  onChange={(e) =>
                    setEditingProduct({
                      ...editingProduct,
                      subtitle: e.target.value,
                    })
                  }
                  placeholder="Enter subtitle"
                  className="adminmodal-input"
                />
              </div>
              <div className="feature-item">
                <label className="feature-label">M.R.P Price</label>

                <input
                  type="text"
                  name="actual_price"
                  value={editingProduct.actual_price}
                  onChange={(e) =>
                    setEditingProduct({
                      ...editingProduct,
                      actual_price: e.target.value,
                    })
                  }
                  placeholder="Enter actual price"
                  className="adminmodal-input"
                />
              </div>

              <div className="feature-item">
                <label className="feature-label">Selling Price</label>

                <input
                  type="text"
                  name="price"
                  value={editingProduct.price}
                  onChange={(e) =>
                    setEditingProduct({
                      ...editingProduct,
                      price: e.target.value,
                    })
                  }
                  placeholder="Enter product price"
                  className="adminmodal-input"
                />
              </div>

              <div className="feature-item">
                <label className="feature-label">Offer label</label>
                <input
                  type="text"
                  name="label"
                  value={editingProduct.label}
                  onChange={(e) =>
                    setEditingProduct({
                      ...editingProduct,
                      label: e.target.value,
                    })
                  }
                  placeholder="Enter label"
                  className="adminmodal-input"
                />
              </div>

              <div className="feature-item">
                <label className="feature-label">Delivery charge</label>
                <input
                  type="text"
                  name="deliverycharge"
                  value={editingProduct.deliverycharge}
                  onChange={(e) =>
                    setEditingProduct({
                      ...editingProduct,
                      deliverycharge: e.target.value,
                    })
                  }
                  placeholder="Enter deliverycharge"
                  className="adminmodal-input"
                />
              </div>
              <div className="feature-item">
                <label className="feature-label">
                  In Stock or Out Of Stock
                </label>

                <select
                  name="status"
                  value={editingProduct.status}
                  onChange={(e) =>
                    setEditingProduct({
                      ...editingProduct,
                      status: e.target.value,
                    })
                  }
                  className="adminmodal-input"
                >
                  <option value="available">In Stock</option>
                  <option value="unavailable">Out Of Stock</option>
                </select>
              </div>
              {userRole === "Admin" && (
                <div className="feature-item">
                  <label className="feature-label">Approve or Unapprove</label>

                  <select
                    disabled={role === "Staff"}
                    name="productStatus"
                    value={editingProduct.productStatus}
                    onChange={(e) =>
                      setEditingProduct({
                        ...editingProduct,
                        productStatus: e.target.value,
                      })
                    }
                    className="adminmodal-input"
                  >
                    <option value="approved">Approve</option>
                    <option value="unapproved">UnApprove</option>
                  </select>
                </div>
              )}
            </div>

            {/* Features Section (Part 2) */}
            <div className="part2">
              <div className="product-features-container">
                <div className="feature-item">
                  <label className="feature-label">Memory</label>
                  <input
                    type="text"
                    name="memory"
                    value={editingProduct.memory}
                    onChange={(e) =>
                      setEditingProduct({
                        ...editingProduct,
                        memory: e.target.value,
                      })
                    }
                    placeholder="Enter memory"
                    className="feature-input"
                  />
                </div>

                <div className="feature-item">
                  <label className="feature-label">Storage</label>
                  <input
                    type="text"
                    name="storage"
                    value={editingProduct.storage}
                    onChange={(e) =>
                      setEditingProduct({
                        ...editingProduct,
                        storage: e.target.value,
                      })
                    }
                    placeholder="Enter storage"
                    className="feature-input"
                  />
                </div>

                <div className="feature-item">
                  <label className="feature-label">Processor</label>
                  <input
                    type="text"
                    name="processor"
                    value={editingProduct.processor}
                    onChange={(e) =>
                      setEditingProduct({
                        ...editingProduct,
                        processor: e.target.value,
                      })
                    }
                    placeholder="Enter processor"
                    className="feature-input"
                  />
                </div>

                <div className="feature-item">
                  <label className="feature-label">Display</label>
                  <input
                    type="text"
                    name="display"
                    value={editingProduct.display}
                    onChange={(e) =>
                      setEditingProduct({
                        ...editingProduct,
                        display: e.target.value,
                      })
                    }
                    placeholder="Enter display"
                    className="feature-input"
                  />
                </div>

                <div className="feature-item">
                  <label className="feature-label">OS</label>
                  <input
                    type="text"
                    name="os"
                    value={editingProduct.os}
                    onChange={(e) =>
                      setEditingProduct({
                        ...editingProduct,
                        os: e.target.value,
                      })
                    }
                    placeholder="Enter OS"
                    className="feature-input"
                  />
                </div>

                {/* Others (Textarea) */}
                <div className="feature-item">
                  <label className="feature-label">Others</label>
                  <textarea
                    name="others"
                    value={editingProduct.others}
                    onChange={(e) =>
                      setEditingProduct({
                        ...editingProduct,
                        others: e.target.value,
                      })
                    }
                    placeholder="Enter other features"
                    className="feature-textarea"
                    rows="4"
                  />
                </div>
                <button
                  onClick={handleUpdateProduct}
                  className="adminmodal-update-btn"
                >
                  Update
                </button>
                <button
                  onClick={() => setModalIsOpen(false)}
                  className="adminmodal-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};



// Custom next arrow component
const SampleNextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div
      className={`${className} `}

      onClick={onClick}
    >

    </div>
  );
};

const SamplePrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div
      className={`${className} `}

      onClick={onClick}
    >

    </div>
  );
};

export default Computers;
